import script from "./SubDepartmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SubDepartmentModal.vue?vue&type=script&setup=true&lang=js"

import "./SubDepartmentModal.vue?vue&type=style&index=0&id=3cce1fb9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cce1fb9"]])

export default __exports__